import React, { useEffect, useState } from "react";
import "./styled.css"

import { setAdminPlusRankingPoints } from "../../../utils/service/ranking";

export default function OptionArea(props) {
  const [nextMenu, setNextMenu] = useState(false);
  useEffect(() => {
    document.getElementById("title-card-optionArea").focus();
  }, []);

  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  // useEffect(() => {
  //   window.addEventListener("keydown", (event) => {
  //     if (event.key === "Tab") {
  //       if (document.activeElement.id === "optionArea-last") {
  //         document.getElementById("sectors-stage2").focus();
  //         return;
  //       }
  //     }
  //   });
  // }, []);
  return (
    <div className="div-cards-talent">
      <div className="card-talent">
        <a className="title-card-talent" id="title-card-optionArea" tabIndex={13}>
          BPO
        </a>
        <video
          width={250}
          controls
          tabIndex={14}
          onPlay={() => pointAction("PALCO2BPO")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20DE%20NEGOCIOS/%C3%81reas%20de%20Neg%C3%B3cios%20-%20BPO%20%28Carlos%20Medeiros%20Rocha%29%20V2023%2022_02%282%29.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          DS
        </a>
        <video
          width={250}
          controls
          tabIndex={15}
          onPlay={() => pointAction("PALCO2DS")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20DE%20NEGOCIOS/%C3%81reas%20de%20Neg%C3%B3cios%20-%20DS%20%28Marco%20Chaves%20Silva%29%20V2023%2022_02.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          EAS
        </a>
        <video
          width={250}
          controls
          tabIndex={16}
          onPlay={() => pointAction("PALCO2EAS")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20DE%20NEGOCIOS/%C3%81reas%20de%20Neg%C3%B3cios%20-%20EAS%20%28ROG%C3%89RIO%29%20V2023%2022_02.mp4" />
        </video>
      </div>

      <div className="card-talent">
        <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
          DT
        </a>
        <video
          width={250}
          controls
          tabIndex={16}
          onPlay={() => pointAction("PALCO2DT")}
        >
          <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20DE%20NEGOCIOS/%C3%81reas%20de%20Neg%C3%B3cios%20-%20Digital%20Technology%20%28PABLO%29%20V2_COM_QR%20CODE.mp4" />
        </video>
      </div>
    </div>
  );
}
